<template>
  <section class="done">
    <Header/>
    <div class="container main" style="margin-top: 50px;background: #fff;">
    <div style="text-align: center;"><i class="el-icon-success"></i></div>
    <h3>提交成功</h3>
    <p>回收订单已提交成功，稍后会有客服人员与您联系并确认订单。</p>
    <el-row style="text-align: center;margin-top: 40px;">
      <el-button type="primary" @click="goUrl('https://www.suhuishou.com/pc/#/oldnew')">订单详情</el-button>
      <el-button type="primary" plain @click="goUrl('https://www.suhuishou.com/pc/#/oldnew')">用户中心</el-button>
    </el-row>
  </div>
    <Footer/>
  </section>
</template>

<script>
import Header from "@/components/PC/Common/Header.vue";
import Footer from "@/components/PC/Common/Footer.vue";
export default {
  name: "Home",
  data() {
    return {
      active: 2,
      order: "233",
      str: []
    };
  },
  components: {
    Header,
    Footer
  },
  mounted: function() {},
  computed: {},
  methods: {
    goUrl(url){
      window.location.href = url;
    }
  },
  created() {
    // this.fetchProduct();
  }
};
</script>
<style scoped>
.main{padding: 0px 20px 60px 20px;}
.main i{display: inline-block;font-size: 80px;color: #52c41a;}
.main h3{text-align: center;font-size: 24px;margin: 20px 0;}
.main p{width: 800px;margin: 20px auto;text-align: center;color: #666}
</style>
